import { FormattedMessage } from "react-intl";
import List from "app/pages/.shared/List";
import PropTypes from "prop-types";
import { memo } from "react";

const IncludedItemsList = ({ titleId, items }) => (
	<div className="included__list">
		<div className="included__title">
			<FormattedMessage id={titleId}>{msg => <span>{`${msg} :`}</span>}</FormattedMessage>
		</div>
		<List items={items} enableHTMLFormatting={true} />
	</div>
);

IncludedItemsList.propTypes = {
	titleId: PropTypes.string.isRequired,
	items: PropTypes.array.isRequired,
};

export default memo(IncludedItemsList);
